<template>
  <div>
    <svg
      v-if="title === 'Admins'"
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5456 1H1.81836V9.18182H16.5456V1Z"
        stroke="#379B7E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1 19V17.3636H4.27273V19"
        stroke="#379B7E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8184 14.0909V12.4545H14.0911V14.0909"
        stroke="#379B7E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.27246 14.0909V12.4545H7.54519V14.0909"
        stroke="#379B7E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.5459 19V17.3636H10.8186V19"
        stroke="#379B7E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0908 19V17.3636H17.3635V19"
        stroke="#379B7E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="title === 'Teachers'"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.32617 19V6.72729"
        stroke="#777FF6"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.87172 4.27273C4.77545 4.27273 5.50808 3.5401 5.50808 2.63636C5.50808 1.73262 4.77545 1 3.87172 1C2.96798 1 2.23535 1.73262 2.23535 2.63636C2.23535 3.5401 2.96798 4.27273 3.87172 4.27273Z"
        stroke="#777FF6"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.41699 19V8.36366C1.41699 7.92967 1.58939 7.51345 1.89627 7.20658C2.20315 6.8997 2.61937 6.72729 3.05336 6.72729H12.8715"
        stroke="#777FF6"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.78027 2.63635H19.4166V13.2727H9.59846"
        stroke="#777FF6"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5078 13.2727L16.9624 19"
        stroke="#777FF6"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="title === 'Staff'"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.1895 11.9085L14.9038 15.1942"
        stroke="#D96D04"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.9043 11.9085L18.19 15.1942"
        stroke="#D96D04"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.38184 9.6788V1.93441C3.38184 1.50692 3.72878 1.15997 4.15627 1.15997H16.5473C16.9748 1.15997 17.3217 1.50692 17.3217 1.93441V8.12992"
        stroke="#D96D04"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.1263 12.7766H1.83301C1.83301 14.0598 2.87308 15.0999 4.15632 15.0999H11.1263"
        stroke="#D96D04"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="title === 'Students'"
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.25 7.85712V12.1428"
        stroke="#A48915"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.82143 9.57143L1.25 5.28571L9.82143 1L18.3929 5.28571L9.82143 9.57143Z"
        stroke="#A48915"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.82129 6.57141V13.8571C3.82129 15.2774 6.50757 16.4286 9.82129 16.4286C13.135 16.4286 15.8213 15.2774 15.8213 13.8571V6.57141"
        stroke="#A48915"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "KpiCardIcons",
  props: {
    title: {
      type: String,
      default: "Admins"
    }
  }
}
</script>
